import posthog from "posthog-js";

// PostHog is optional at runtime: local dev and preview builds often run without
// a project key. Guard init so a missing key degrades to a no-op instead of
// spamming the console or throwing inside `capture`/`identify` calls.
const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || "https://us.i.posthog.com";

export const analyticsEnabled = Boolean(POSTHOG_KEY);

if (analyticsEnabled) {
  posthog.init(POSTHOG_KEY as string, {
    api_host: POSTHOG_HOST,
    // We capture pageviews manually via the router (see RootLayout) so we can
    // attach the matched route pattern rather than the raw URL.
    capture_pageview: false,
    capture_pageleave: true,
    // Only create person profiles for identified (signed-in) users — anonymous
    // visitors still get events, but don't inflate the billed person count.
    person_profiles: "identified_only",
    // Autocapture clicks/inputs for exploratory funnels on top of our explicit,
    // typed events. Never record the *values* users type.
    autocapture: true,
    // Session replay for debugging + behavioral analysis, with privacy defaults:
    // every input is masked and we never record raw text typed into fields.
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-ph-mask]",
    },
    // Route console errors/rejections into PostHog too, so an error is one click
    // away from its session replay (Sentry remains the primary alerting path).
    capture_exceptions: true,
    // Respect Do Not Track.
    respect_dnt: true,
  });
} else if (import.meta.env.DEV) {
  // Loud in dev, silent in prod builds where the key is simply absent.
  console.info("[analytics] VITE_POSTHOG_KEY not set — PostHog disabled (no-op).");
}

export { posthog };
